import { createDownloadableLink } from '../../../helpers';
import { synthesize } from 'redux-dispatcher';

const mapDispatchToAC = {
  showHideLoadingAction: (payload) => payload,
  getStudioClassList:
    (search, paging, sortOption = {}, filterOption = {}) =>
    async ({ Api, getState }) => {
      const pagingData = paging || getState().studioClass.paging;
      const { pageIndex, pageSize } = pagingData;

      const { result, status } = await Api.post(`workouts/filter`, {
        pageIndex,
        pageSize,
        search,
        ...sortOption,
        ...filterOption,
      });
      status === 200 && StudioClassDispatcher.getStudioClassListSuccess(result);
    },
  getStudioClassListSuccess: (payload) => payload,

  getDurationIntensity:
    () =>
    async ({ Api }) => {
      const { result, status } = await Api.get(`workouts/duration_intensity`);
      status === 200 &&
        StudioClassDispatcher.getDurationIntensitySuccess(result);
    },
  getDurationIntensitySuccess: (payload) => payload,

  getCategoryStudioClass:
    () =>
    async ({ Api }) => {
      const { result, status } = await Api.post(`categories/filter`, {
        categoryType: 'StudioClass',
      });
      status === 200 &&
        StudioClassDispatcher.getCategoryStudioClassSuccess(result);
    },
  getCategoryStudioClassSuccess: (payload) => payload,

  getAvailableTrainer:
    () =>
    async ({ Api }) => {
      const { result, status } = await Api.get(`workouts/trainer`);
      status === 200 &&
        StudioClassDispatcher.getAvailableTrainerSuccess(result);
    },
  getAvailableTrainerSuccess: (payload) => payload,

  getStudio:
    () =>
    async ({ Api }) => {
      const { result, status } = await Api.post(`studios/filter`, {});
      status === 200 && StudioClassDispatcher.getStudioSuccess(result);
    },
  getStudioSuccess: (payload) => payload,

  getStudioClassById:
    (id, callbackSuccess) =>
    async ({ Api }) => {
      const { result, status } = await Api.get(`workouts/${id}`);
      status === 200 && callbackSuccess(result);
    },

  addStudioClass:
    (payload, callbackSuccess) =>
    async ({ Api, customToast }) => {
      const { result, status, message } = await Api.post(
        `workouts/live-stream`,
        payload
      );
      StudioClassDispatcher.showHideLoadingAction({ loading: false });
      if (status === 200) {
        callbackSuccess(result);
        return customToast('success', message || 'Success');
      }
    },

  editStudioClass:
    (payload, callbackSuccess) =>
    async ({ Api, customToast }) => {
      const { data, id } = payload;

      const { result, status } = await Api.put(
        `workouts/live-stream/${id}`,
        data
      );
      StudioClassDispatcher.showHideLoadingAction({ loading: false });
      if (status === 200) {
        callbackSuccess(result);
        return customToast('success', 'Success');
      }
    },
  editStudioClassSuccess: (payload) => payload,

  deleteStudioClass:
    (workoutId, callbackSuccess) =>
    async ({ Api, customToast }) => {
      const { status } = await Api.delete(`workouts/${workoutId}`);
      if (status === 200) {
        customToast('success', 'Deleted successfully');
        callbackSuccess();
      }
    },
  getExportExcel:
    () =>
    async ({ Api }) => {
      let { result, status } = await Api.get(
        `workout-reports/studio-class-csv`
      );
      status === 200 && createDownloadableLink(result);
    },
};

const StudioClassDispatcher = synthesize('studioClass', mapDispatchToAC);
export default StudioClassDispatcher;
